import { render, staticRenderFns } from "./CommunityAppStore.vue?vue&type=template&id=7f83b143&scoped=true&"
import script from "./CommunityAppStore.vue?vue&type=script&lang=js&"
export * from "./CommunityAppStore.vue?vue&type=script&lang=js&"
import style0 from "./CommunityAppStore.vue?vue&type=style&index=0&id=7f83b143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83b143",
  null
  
)

export default component.exports